import React from 'react';
import { Box, Typography } from '@mui/material';

const InfoRow = ({ label, value }) => (
  <Box sx={{ display: 'flex', flexDirection: 'column', mb: 2 }}>
    <Typography variant="caption" sx={{ fontWeight: 600, color: 'text.secondary', textTransform: 'uppercase', letterSpacing: 0.5 }}>
      {label}
    </Typography>
    <Typography variant="body1" sx={{ fontWeight: 500, color: 'text.primary' }}>
      {value || '--'}
    </Typography>
  </Box>
);

const ProfilePersonal = ({ empData }) => {
  return (
    <Box>
      <Typography variant="subtitle1" sx={{ fontWeight: 700, color: 'text.primary', mb: 3, borderBottom: '2px solid #E2E8F0', pb: 1.5 }}>
        Personal Details
      </Typography>
      
      <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 3 }}>
        <InfoRow label="First Name" value={empData.first_name} />
        <InfoRow label="Last Name" value={empData.last_name} />
        <InfoRow label="Date of Birth" value={empData.dob} />
        
        <InfoRow label="Father's Name" value={empData.father_name} />
        <InfoRow label="Mother's Name" value={empData.mother_name} />
        <InfoRow label="Blood Group" value={empData.blood_group} />
        
        <InfoRow label="Gender" value={empData.gender} />
        <InfoRow label="Personal Email" value={empData.email} />
        <InfoRow label="Mobile" value={empData.mobile} />
      </Box>
      
      <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 3, mt: 1 }}>
        <InfoRow label="Address" value={empData.address} />
        <InfoRow label="Location" value={empData.location} />
      </Box>
    </Box>
  );
};

export default ProfilePersonal;